import { IListState, PaginationType } from '@typings/requestPayloads'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'
import cloneDeep from 'lodash/cloneDeep'

export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
    needPopulate?: boolean
    populates?: any[]
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listMeetingRequests = createSlice({
    name: 'meeting-requests/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        replaceItem(state, action) {
            const findIndex = state.data.findIndex(item => item._id === action.payload._id)
            const newState = cloneDeep(action.payload)
            if (!newState.hostId?.lastname) {
                newState.hostId = state.data[findIndex].hostId
            }
            state.data[findIndex] = newState
        }
    }
})

export const listMeetingRequestsActions = listMeetingRequests.actions
export default listMeetingRequests.reducer
